<template>
  <div class="col-xs-12 col-md-12 form-group">
    <label class="control-label" v-if="label">{{ label }}</label>
    <ckeditor-classic
      size="350px"
      :name="name"
      :value="value"
      :data-vv-as="label"
      :placeholder="placeholder"
      @input="$emit('input', $event)"
      v-validate="{ required: required }"
    />
  </div>
</template>

<script>
export default {
  name: "c-protocolo-text-area-parcelamento",
  $_veeValidate: {
    validator: "new"
  },
  inject: ["$validator"],
  props: {
    label: String,
    id: String,
    name: {
      required: true,
      type: String
    },
    disabled: Boolean,
    placeholder: String,
    readonly: Boolean,
    value: String,
    required: Boolean
  },
  mounted() {
    this.$el.value = this.value;
  },
  computed: {
    usuario() {
      return this.$store.state.usuario;
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/UIComponents/Protocolo/Campos/TextAreaParcelamento.vue